import styled, { css } from 'styled-components';
import { ButtonVariant, ShapeVariant, SizeVariant } from './types';

export const MeetButton = styled.button`
    display: flex;
    align-items: center;
    min-height: 40px;
    border-radius: 44px;
    border: none;
    background: ${(props) => props.theme.root.colors.basicColors['10%']};
    padding: 4px 16px;
    cursor: pointer;
    color: ${(props) => props.theme.root.colors.basicColors['90%']};
    font-weight: normal;
    font-size: 14px;
    white-space: nowrap;

    &:active {
        border: none;
    }

    &:hover {
        background: ${(props) => props.theme.root.colors.basicColors['15%']};
    }

    &:disabled {
        opacity: 0.5;
        cursor: default;
    }

    .icon {
        display: inline-block;
        margin-right: 8px;
    }
`;

export const StyledControlButton = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    outline: none;
`;

export const MainButton = styled.button<{
    $variant: ButtonVariant;
    $on: boolean;
    $hasDropdown: boolean;
    $shape: ShapeVariant;
    $size: SizeVariant;
}>`
    display: flex;
    align-items: center;
    min-height: 40px;
    border-radius: 44px;
    border: none;
    background: ${(props) => props.theme.root.colors.basicColors['10%']};
    padding: 4px 16px;
    cursor: pointer;
    color: ${(props) => props.theme.root.colors.basicColors['90%']};
    font-weight: normal;
    font-size: 14px;
    white-space: nowrap;

    &:active {
        border: none;
    }

    &:hover {
        background: ${(props) => props.theme.root.colors.basicColors['15%']};
    }

    &:disabled {
        background: ${(props) => props.theme.root.colors.basicColors['4%']};
        cursor: default;

        /* Делаем прозрачным всё внутри, кроме псевдоэлементов (чтобы не изменять прозрачность tooltip) */
        & > * {
            opacity: 0.5;
        }
    }

    ${(props) => {
        if (!props.$on) {
            return css`
                background: ${props.theme.root.colors.basicColors.white['80%']};

                &:hover {
                    background: ${props.theme.root.colors.basicColors.white['100%']};
                }

                svg {
                    path {
                        fill: ${props.theme.root.colors.basicColors.black['95%']};
                    }

                    rect {
                        stroke: ${props.theme.root.colors.basicColors.black['95%']};
                    }
                }
            `;
        }

        return null;
    }}

    ${(props) => {
        if (props.$hasDropdown) {
            return css`
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                padding-left: 16px;
                padding-right: 16px;
                margin-right: 0;
            `;
        }

        return null;
    }}

    ${({ $variant }) => {
        switch ($variant) {
            case 'success':
                return css`
                    background-color: ${(props) => props.theme.root.button['success'].background};

                    &:hover {
                        background: ${(props) => props.theme.root.button['success'].hoverBackground};
                    }
                `;
            case 'danger':
                return css`
                    background: ${(props) => props.theme.root.button['danger'].background};

                    &:hover {
                        background: ${(props) => props.theme.root.button['danger'].hoverBackground};
                    }
                `;

            default:
                return undefined;
        }
    }}

    ${({ $shape }) => {
        switch ($shape) {
            case 'circle':
                return css`
                    border-radius: 50%;
                    padding: 8px;
                `;

            case 'rectangle':
                return css`
                    border-radius: 6px;
                `;
        }

        return null;
    }}

        ${({ $size }) => {
        switch ($size) {
            case 'small':
                return css`
                    min-height: 32px;
                `;

            case 'medium':
                return css`
                    min-height: 40px;
                `;
        }

        return null;
    }}
`;

export const ButtonSeparator = styled.div<{
    $on: boolean;
}>`
    display: block;
    background-repeat: no-repeat;
    background: ${(props) =>
        props.$on ? props.theme.root.colors.basicColors['10%'] : props.theme.root.colors.basicColors.white['80%']};
    width: 1px;
    align-self: stretch;
    position: relative;

    &:after {
        background: ${(props) =>
            props.$on
                ? props.theme.root.colors.basicColors['10%']
                : (props) => props.theme.root.colors.basicColors.black['10%']};
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 0;
        height: 50%;
        width: 1px;
        transform: translateY(-50%);
    }
`;
